<template>
  <div>
    <v-card class="elevation-6" v-if="!verification_card_visible">
      <v-card-text>
        <p class="mt-5 display-1 text-center">
          <v-img
            class="logo-iph-sys"
            src="../../assets/images/layout/logo-iph-sistemas-instituto-pro-hemoce.png"
          ></v-img>
        </p>
        <p class="text-center">Informe seus dados para acessar a área administrativa</p>
      </v-card-text>
      <v-card-text v-if="messageError" class="m-0 p-0">
        <v-alert dense text type="error" class="ma-0">
          <strong>Email</strong> ou <strong>Senha</strong> está <strong>inválido</strong>.
        </v-alert>
      </v-card-text>

      <v-card-text v-if="isIOS" class="m-0 p-0">
        <v-alert dense text type="error" class="ma-0">
          <strong>Utilize o navegador Safari ou Chrome</strong>.
        </v-alert>
      </v-card-text>

      <v-card-text v-if="messageSuccess" class="m-0 p-0">
        <v-alert dense text type="success" class="ma-0">
          <strong> Redirecionando </strong>.
          <v-progress-linear indeterminate color="green"></v-progress-linear>
        </v-alert>
      </v-card-text>

      <v-card-text>
        <v-form>
          <v-text-field
            :disabled="progress || messageSuccess"
            dense
            solo
            v-model.trim="$v.form.email.$model"
            type="email"
            label="Digite seu email"
            prepend-icon="mdi-email"
            color="red"
          ></v-text-field>
          <v-text-field
            :disabled="progress || messageSuccess"
            dense
            solo
            v-model.trim="$v.form.password.$model"
            type="password"
            label="Digite seu senha"
            prepend-icon="mdi-lock"
            color="red"
          ></v-text-field>

          <v-btn
            v-if="!progress"
            block
            large
            class="mb-5 bbb"
            :disabled="$v.$invalid"
            color="bbbb btn-bg-red-1 l-text-white"
            @click="login"
          >
            Acessar
            <v-icon dark right>mdi-logout-variant</v-icon>
          </v-btn>

          <v-card-text class="m-0 p-0" align="center" v-else>
            <v-progress-circular :size="50" color="red" indeterminate> </v-progress-circular>
          </v-card-text>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="elevation-6" v-if="verification_card_visible">
      <v-card-text>
        <p class="mt-5 display-1 text-center">
          <v-img
            class="logo-iph-sys"
            src="../../assets/images/layout/logo-iph-sistemas-instituto-pro-hemoce.png"
          ></v-img>
        </p>
        <p class="text-center">Insira o código de verificação que foi enviado para seu e-mail e/ou celular.</p>
      </v-card-text>
      <v-card-text v-if="message_error_code" class="m-0 p-0">
        <v-alert dense text type="error" class="ma-0">
          <strong>{{ message_error_code }}</strong
          >.
        </v-alert>
      </v-card-text>

      <v-card-text v-if="messageSuccess" class="m-0 p-0">
        <v-alert dense text type="success" class="ma-0">
          <strong> Redirecionando </strong>.
          <v-progress-linear indeterminate color="green"></v-progress-linear>
        </v-alert>
      </v-card-text>

      <v-card-text>
        <v-form>
          <v-text-field
            dense
            solo
            v-model.trim="$v.form.verification_code.$model"
            type="text"
            label="Digite o código de verificação"
            prepend-icon="mdi-lock"
            color="red"
            :error-messages="errors.verification_code"
          ></v-text-field>
          <v-container class="ma-0 pa-0" fluid>
            <a @click="resendCode">Reenviar código de verificação.</a>
          </v-container>
          <v-btn
            v-if="!progress"
            block
            large
            class="my-4 bbb"
            :disabled="$v.$invalid"
            color="bbbb btn-bg-red-1 l-text-white"
            @click="login"
          >
            Acessar
            <v-icon dark right>mdi-logout-variant</v-icon>
          </v-btn>

          <v-card-text class="m-0 p-0" align="center" v-else>
            <v-progress-circular :size="50" color="red" indeterminate> </v-progress-circular>
          </v-card-text>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'FormLogin',
  data: () => {
    return {
      isIOS: false,
      progress: '',
      messageSuccess: '',
      messageError: '',
      message_error_code: '',
      verification_card_visible: false,
      form: {
        email: '',
        password: '',
        verification_code: '',
      },
      errors: {
        email: [],
        password: [],
        verification_cade: [],
      },
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      verification_code: {},
    },
  },
  created() {
    this.form.email = this.GET_email
    this.form.password = this.GET_password
    this.progress = this.GET_process
    this.messageSuccess = this.GET_successMessage
    this.messageError = this.GET_errorMessage
  },
  mounted: function () {},
  computed: {
    ...mapGetters('auth', [
      'GET_email',
      'GET_password',
      'GET_process',
      'GET_successMessage',
      'GET_errorMessage',
    ]),
  },
  watch: {
    GET_email: function () {
      this.form.email = this.GET_email
    },
    GET_password: function () {
      this.form.password = this.GET_password
    },
    GET_process: function () {
      this.progress = this.GET_process
    },
    GET_successMessage: function () {
      this.messageSuccess = this.GET_successMessage
    },
    GET_errorMessage: function () {
      this.messageError = this.GET_errorMessage
    },
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('auth', ['ActionLogin', 'ActionResendCode']),
    async login() {
      this.ActionSetLoading(true)
      try {
        await this.ActionLogin(this.form)
      } catch (error) {
        if (error.status == 401)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: error.body.message,
          })
        else if (error.status == 403) {
          this.verification_card_visible = true
        } else if (error.status == 422) {
          this.message_error_code = 'Código de verificação incorreto'
        }
      }
      this.ActionSetLoading(false)
    },
    async resendCode() {
      this.ActionSetLoading(true)
      try {
        await this.ActionResendCode()
        this.$swal({
          icon: 'success',
          title: 'Reenviado',
          text: 'Código reenviado com sucesso, verifique seu email.',
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
  },
}
</script>
